import { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { getSequnceSort } from "../../utils/helper";
const MyPlanHeader = ({ myplan, index, planIndex, setPlanIndex, planBadgesCourse }) => {
    const toggleAccordion = (index) => {
        setPlanIndex(planIndex === index ? null : index);
    }

    const [allUnlockedBadges, setAllUnlockedBadges] = useState(0);
    // console.log('planBadgesCourse :', planBadgesCourse)
    /*
    useEffect(() => {
        const unlockedBadges = planBadgesCourse?.filter(course => course?.badges?.some(badge => !badge?.isLock)) // Only courses with at least one unlocked badge
            ?.map(course =>
                course?.badges?.filter(badge => !badge?.isLock) // Only unlocked badges from those courses
            );

        setAllUnlockedBadges(unlockedBadges?.flat()?.length);
        //  console.log('unlockedBadges :', unlockedBadges, allUnlockedBadges)
    }, [planBadgesCourse])
    */

    return (
        <div className="panneltitles ">
            <div className="contenttitle flexone">
                <h2 className="flextwo ">{myplan?.name}
                    <ul className="ml-3">
                        {planBadgesCourse?.length > 0 &&
                            planBadgesCourse?.map((planData, index) => (
                                planData?.id === myplan?.id && (
                                    <>
                                        {
                                            getSequnceSort(planData?.badges)?.filter((badge) => !badge?.isLock || myplan?.isRecommendedPlan)?.map((data, key) => (
                                                key < 2 &&
                                                <>
                                                    <li key={key} className={`${data?.isLock && "opacitydwn"}`}>
                                                        <img src={data?.imageUrl} alt="badgesicon" className="icon" />
                                                    </li >
                                                </>
                                            ))
                                        }
                                        {myplan?.isRecommendedPlan ? (
                                            <li className="totlenobadge"><span>+14</span></li>
                                        ) : planData?.badges?.length > 0 && planData?.badges?.filter((badge) => !badge?.isLock)?.length > 2 && (
                                            <li className="totlenobadge">
                                                <span>+{planData?.badges?.filter((badge) => !badge?.isLock)?.length - 2}</span>
                                            </li>
                                        )}
                                    </>
                                )
                            ))
                        }
                        {/* <li className="totlenobadge">
                            <span>+5</span>
                        </li> */}
                        {/* <li className=""><img src={image.badges_icons1} alt="badgesicon" className="icon" /></li>
                        <li><img src={image.badges_icons2} alt="badgesicon" className="icon" /></li>
                        <li className="opacitydwn"><img src={image.badges_icons3} alt="badgesicon" className="icon" /></li>
                        <li className="opacitydwn"><img src={image.badges_icons4} alt="badgesicon" className="icon" /></li> */}
                    </ul>

                </h2>

                {/* <span className="dropdwnicon"><i class="fa-regular fa-angle-down"></i></span> */}
                <span
                    className="dropdwnicon pointer flexfive"
                    href={"#showUserPlan" + index}
                    aria-expanded={planIndex === index}
                    onClick={() => toggleAccordion(index)}
                >
                    <i className="fa-light fa-chevron-down"></i>
                </span>
            </div>

        </div >
    )
}
export default MyPlanHeader;